import { selectedVideoIdsAtom } from '@/atoms/video';
import { usePlaylistCurrentlySelected } from '@statsbomb/video-client-js';
import { useAtomValue } from 'jotai';

export const useCurrentlySelectedVideoId = () => {
  const [videoPlaylistCurrentlySelected] = usePlaylistCurrentlySelected();
  const selectedVideoIds = useAtomValue(selectedVideoIdsAtom);
  return selectedVideoIds?.length && videoPlaylistCurrentlySelected?.id ? videoPlaylistCurrentlySelected.id : null;
};
